import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import useResizeObserver from 'use-resize-observer';

//works for components with ref forwarded!
export default (WrappedComponent) => {
    const WithHeightChange = ({ onHeightChange,  ...props }) => {
        const { ref, height} = useResizeObserver();

        useEffect(() => {
            onHeightChange && onHeightChange(height);
        }, [height]);

        return <WrappedComponent
                    ref={ref}
                    {...props}
                />;

    }

    WithHeightChange.propTypes = {
        onHeightChange: PropTypes.func
    }

    return WithHeightChange;
}
